import { X, Check } from 'lucide-react'
import { cn } from '@/lib/utils'

const traditionalFeatures = [
  'Unpredictable costs with 10-15% annual increases',
  'Limited network options',
  'Weeks of paperwork and manual enrollment',
]

const benepicksFeatures = [
  'Fixed, predictable monthly budget',
  'Employees pick what works for them',
  '5-minute setup with automated sync',
]

export const Comparison = () => {
  return (
    <section className="py-20 sm:py-28 lg:py-32 px-4 sm:px-6 lg:px-8 bg-neutral-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-neutral-900 leading-tight">
            Group Health <span className="text-neutral-400">vs</span> Benepicks
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 sm:gap-6 lg:gap-8 items-stretch">
          <div
            className={cn(
              'bg-white rounded-2xl sm:rounded-3xl',
              'p-6 sm:p-8 lg:p-10',
              'border border-neutral-200/80',
              'shadow-sm',
              'transition-all duration-300',
              'hover:shadow-md'
            )}
          >
            <h3 className="text-xl sm:text-2xl font-bold mb-6 sm:mb-8 text-neutral-900">
              Traditional Group Health
            </h3>
            <div className="space-y-4 sm:space-y-5">
              {traditionalFeatures.map((item, i) => (
                <div key={i} className="flex items-start gap-3 sm:gap-4">
                  <div
                    className={cn(
                      'w-5 h-5 sm:w-6 sm:h-6 rounded-full',
                      'bg-red-50 border border-red-100',
                      'flex items-center justify-center flex-shrink-0',
                      'mt-0.5'
                    )}
                  >
                    <X
                      className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-red-500"
                      strokeWidth={3}
                    />
                  </div>
                  <span className="text-sm sm:text-base text-neutral-500 leading-relaxed">
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div
            className={cn(
              'relative',
              'bg-gradient-to-br from-white to-orange-50/30',
              'rounded-2xl sm:rounded-3xl',
              'p-6 sm:p-8 lg:p-10',
              'border-2 border-orange-primary',
              'shadow-xl shadow-orange-primary/10',
              'transition-all duration-300',
              'hover:shadow-2xl hover:shadow-orange-primary/15'
            )}
          >
            <div className="absolute inset-0 overflow-hidden rounded-[calc(1rem-2px)] sm:rounded-[calc(1.5rem-2px)] pointer-events-none">
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-orange-primary/8 blur-3xl rounded-full" />
              <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-orange-100/50 blur-3xl rounded-full" />
            </div>

            <div
              className={cn(
                'absolute -top-3.5 left-1/2 -translate-x-1/2',
                'bg-orange-primary text-white',
                'px-4 sm:px-5 py-1.5 sm:py-2 rounded-full',
                'text-[10px] sm:text-xs font-bold uppercase tracking-[0.15em]',
                'shadow-lg shadow-orange-primary/30'
              )}
            >
              Recommended
            </div>

            <div className="relative z-10">
              <h3 className="text-xl sm:text-2xl font-bold mb-6 sm:mb-8 text-neutral-900">
                Benepicks ICHRA
              </h3>
              <div className="space-y-4 sm:space-y-5">
                {benepicksFeatures.map((item, i) => (
                  <div key={i} className="flex items-start gap-3 sm:gap-4">
                    <div
                      className={cn(
                        'w-5 h-5 sm:w-6 sm:h-6 rounded-full',
                        'bg-transparent border-2 border-orange-primary',
                        'flex items-center justify-center flex-shrink-0',
                        'mt-0.5'
                      )}
                    >
                      <Check
                        className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-orange-primary"
                        strokeWidth={2.5}
                      />
                    </div>
                    <span className="text-sm sm:text-base text-neutral-900 font-medium leading-relaxed">
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
